<template>
  <div>
    <div class="container">
      <div class="left">
        <p class="title">组织架构</p>
        <div class="search">
          <a-input-search
              v-model="formData.name"
              placeholder="搜索组织"
              size="large"
              @search="search"
          >
            <template #enterButton @click="search">
              <img class="img" src="@/assets/images/search.jpg" />
            </template>
          </a-input-search>
        </div>
        <div class="list">
          <div class="item" :class="currentOrg===index?'active':''" v-for="(item,index) in orgList" :key="index" @click="changeOrg(index)">
            {{item.name}}
          </div>
        </div>
      </div>
      <div class="right">
      <div class="top">
        <div style="display: flex;align-items: center;">
          <el-button @click="exportExcel" type="primary">导出数据</el-button>
          <el-button
              type="primary"
              plain
              @click="openRules"
          >绩效规则</el-button>
        </div>
        <div class="search">
          <el-date-picker
              style="width: 300px"
              v-model="dateValue"
              type="daterange"
              :clearable="false"
              range-separator="至"
              start-placeholder="开始日期"
              @change="dateChange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              end-placeholder="结束日期">
          </el-date-picker>
          <el-select style="margin: 0 10px;width: 180px" v-model="orgIds" multiple placeholder="组织类型">
            <el-option label="部门" value="1"></el-option>
            <el-option label="乡镇" value="2"></el-option>
          </el-select>
          <el-select style="width: 180px" v-model="selectValue" multiple collapse-tags placeholder="得分项" @change="selectChange">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-button style="margin-left: 10px" type="primary" @click="searchTwo"
          >查询</el-button
          >
        </div>
      </div>
      <coententTable
          :y="580"
          @handleTableChange="handleTableChange"
          @onShowSizeChange="onShowSizeChange"
          :columns="columns"
          :dataSource="dataSource"
          :loading="loading"
          ref="tableRef"
      >
      </coententTable>
    </div>
    <PerformanceRules v-if="dialogVisible" @handleClose="handleClose" :dialogVisible="dialogVisible"></PerformanceRules>
    </div>
  </div>
</template>

<script>
//创建时间：2023/10/25 10:29:45
import {getCountyList, getTableList} from "./performance";
import coententTable from "@/components/coentent_table.vue";
import PerformanceRules from "./performance_rules.vue"
import ExportJsonExcel from "js-export-excel"
import {message} from "ant-design-vue";
export default {
  components: {
    coententTable,
    PerformanceRules
  },
  data() {
    return {
      dateValue:["2023-10-01","2023-10-30"],
      dialogVisible:false,
      dataSource:[],
      pickerOptions:{
        disabledDate(time) {
          let date = new Date(time);
          let year = date.getFullYear();
          let month = date.getMonth()+1;
          let day = date.getDate();
          return year<2023||year<=2023&&month<10&&day>=1;
        }
      },
      formData:{
        name:""
      },
      tableForm:{
        typeId: "1,2",
        startTime: "2023-10-01",
        endTime: "2023-10-30",
        orgId: null
      },
      orgList:[],
      orgIds:["1","2"],
      currentOrg:0,
      loading: true,
      columns:[
        {
          title: "排名",
          dataIndex: "index",
          width:90,
          customRender: (text, record, index) => index + 1,
        },
        {
          title: "组织机构",
          dataIndex: "orgName",
          width:200,
          ellipsis: true,
        },
        {
          title: "类型",
          dataIndex: "typeName",
          ellipsis: true,
        },
        {
          title: "登录数",
          dataIndex: "loginDay",
          ellipsis: true,
        },
        {
          title: "登录得分",
          colSpan:1,
          dataIndex: "loginMark",
          ellipsis: true,
          customRender: (value) => {
            const obj = {
              children: value,
              attrs: {},
            };
            if(!this.selectValue.includes('1')){
              obj.attrs.colSpan = 0;
            }else{
              obj.attrs.colSpan = 1;
            }
            return obj
          }
        },
        {
          title: "发稿数",
          dataIndex: "reports",
          ellipsis: true,
        },
        {
          title: "发稿得分",
          colSpan:1,
          dataIndex: "reportsMark",
          ellipsis: true,
          customRender: (value) => {
            const obj = {
              children: value,
              attrs: {},
            };
            if(!this.selectValue.includes('2')){
              obj.attrs.colSpan = 0;
            }else{
              obj.attrs.colSpan = 1;
            }
            return obj
          }
        },
        {
          title: "报送得分",
          colSpan:1,
          dataIndex: "adoptMark",
          ellipsis: true,
          customRender: (value) => {
            const obj = {
              children: value,
              attrs: {},
            };
            if(!this.selectValue.includes('3')){
              obj.attrs.colSpan = 0;
            }else{
              obj.attrs.colSpan = 1;
            }
            return obj
          }
        },
        {
          title: "总分",
          dataIndex: "countMark",
          ellipsis: true,
        },
      ],
      selectValue:["1","2","3"],
      orgTypeList:[],
      options:[
        {
          value: "1",
          label: '登录得分'
        },
        {
          value: "2",
          label: '发稿得分'
        },
        {
          value: "3",
          label: '报送得分'
        }
      ]
    }
  },
  methods: {
    netWork() {
      getCountyList(this.formData).then(res=>{
        this.orgList = res.data;
        this.tableList();
      })
    },
    tableList(){
      this.tableForm.orgId = this.orgList[this.currentOrg].id;
      getTableList(this.tableForm).then(res=>{
        this.dataSource = res.data;
        this.loading = false;
      })
    },
    selectChange(val){
      this.columns.map(item=>{
        if(item.title === "登录得分"){
          if(val.includes("1")){
            item.colSpan = 1;
          }else{
            item.colSpan = 0;
          }
        }
        if(item.title === "发稿得分"){
          if(val.includes("2")){
            item.colSpan = 1;
          }else{
            item.colSpan = 0;
          }
        }
        if(item.title === "报送得分"){
          if(val.includes("3")){
            item.colSpan = 1;
          }else{
            item.colSpan = 0;
          }
        }
      })
      this.$refs.tableRef.$forceUpdate();
    },
    search(){
        this.currentOrg = 0;
        this.loading = true;
        this.netWork();
    },
    searchTwo(){
      if(this.orgIds.length===0){
        message.error("组织类型不能为空");
        return;
      }
      this.loading = true;
      this.tableForm.typeId = this.orgIds.join(",");
      this.tableList();
    },
    changeOrg(index){
      if(this.loading===false) {
        this.currentOrg = index;
        this.loading = true;
        this.netWork();
      }
    },
    openRules(){
      this.dialogVisible = true;
    },
    handleClose(){
      this.dialogVisible = false;
    },
    dateChange(val){
      this.tableForm.startTime = val[0];
      this.tableForm.endTime = val[1];
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.formData.current = current;
      this.getListPage();
    },
    handleTableChange(page, pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.formData.current = 1;
      this.formData.size = pageSize;
      this.getListPage();
    },
    exportExcel(){
      let startArr = this.tableForm.startTime.split("-")
      let startTime = startArr[0]+"年"+startArr[1]+"月"+startArr[2]+"日";
      let endArr = this.tableForm.endTime.split("-");
      let endTime = endArr[0]+"年"+endArr[1]+"月"+endArr[2]+"日";
      let option = {
        fileName:startTime+"-"+endTime+"绩效统计",
        datas:[]
      };
      let sheetFilter = [];
      let sheetHeader = [];
      this.columns.map(item=>{
        if(item.colSpan!==0){
          sheetFilter.push(item.dataIndex);
          sheetHeader.push(item.title);
        }
      })
      option.datas = [
        {
          sheetData:this.dataSource.map((item,index)=>{
            const result = {};
            this.columns.map(i=>{
              if(i.colSpan!==0) {
                result[i.dataIndex] = item[i.dataIndex] === null || item[i.dataIndex] === undefined ? index + 1 : item[i.dataIndex]
              }
            })
            return result;
          }),
          sheetName:option.fileName,
          sheetFilter,
          sheetHeader,
          columnWidths: this.columns.map(() => 10),
        }
      ]
      const toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();
    },
  },
  mounted() {
    this.netWork();
  },
}
</script>

<style scoped lang="less">
/deep/ .el-range-editor.el-input__inner{
  justify-content: space-between;
}
/deep/.el-date-editor .el-range-input{
  width: 100px;
}
.container {
  display: flex;
  justify-content: space-between;
  >.right{
    width: 100%;
    padding: 0 24px;
    >.top {
      padding: 24px 24px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .search {
        display: flex;
      }
    }
  }
  .left{
    width: 245px;
    height: 80vh;
    padding: 0 24px;
    border-right: solid 1px #E5E5E5;
    font-size: 14px;
    color: #000;
    >.list{
      overflow-y:scroll;
      height: 87%;

      >.active{
        border-radius: 4px;
        background-color: rgb(236, 245, 255);
        color:#176DE6;
      }
      >.item{
        padding: 0 12px;
        display: flex;
        align-items: center;
        height: 36px;
        cursor: pointer;
      }
    }
      .title {
        margin-bottom: 24px;
        font-weight: bold;
      }
      .search {
        margin-bottom: 12px;
      }
      /deep/ .ant-btn-primary {
        background: #1890ff;
        padding: 0 5px;
      }
      /deep/ input::-webkit-input-placeholder {
        color: #415058;
      }
      /deep/ .ant-input {
        background: #f7f7f7;
      }
    }
}
</style>